module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-virtualized/~/babel-runtime/core-js/object/get-own-property-descriptor.js
 ** module id = 1344
 ** module chunks = 0
 **/